// ================================
// custom mobile navigation script start
// ================================

const rightPanel = document.querySelector('.menu-drawer__navigation_right');

function handleExpand() {
  const parentItem = this.closest('.menu-drawer__navigation_left_item');
  if (!parentItem || parentItem.dataset.active === 'true') { return; }
  Array.from(parentItem.parentElement.children).forEach((el) => el.setAttribute('data-active', 'false'));
  parentItem.setAttribute('data-active', 'true');
  const menuElement = parentItem.querySelector('[data-index]');
  if (menuElement) {
    handleMenu.call(menuElement);
  }
}
function handleMenu() {
  document.querySelectorAll('.menu-drawer__navigation_left [data-index]').forEach((el) => el.setAttribute('data-active', 'false'));
  this.setAttribute('data-active', 'true');
  const dataIndex = this.getAttribute('data-index');
  const target = document.querySelector(`.menu-drawer__navigation_right [data-index='${dataIndex}']`);
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

const navLeft = document.querySelector('.menu-drawer__navigation_left');
if (navLeft) {
  navLeft.addEventListener('click', (e) => {
    const title = e.target.closest('.menu-drawer__navigation_left_tab_item_title');
    if (title && navLeft.contains(title)) {
      handleExpand.call(title);
    }
  });
  navLeft.addEventListener('click', (e) => {
    const item = e.target.closest('.menu-drawer__navigation_left_tab_item_content [data-index]');
    if (item && navLeft.contains(item)) {
      handleMenu.call(item);
    }
  });
}

const activeIndexSet = new Set();
let debounceTimer = null;
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      activeIndexSet.add(entry.target.dataset.index);
    } else {
      activeIndexSet.delete(entry.target.dataset.index);
    }
  });
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }
  debounceTimer = setTimeout(() => {
    const firstActiveIndex = Array.from(activeIndexSet).sort((a, b) => {
      const [a1, a2] = a.split('-').map(Number);
      const [b1, b2] = b.split('-').map(Number);
      if (a1 !== b1) return a1 - b1;
      return a2 - b2;
    })[0];
    if (!firstActiveIndex) { return; }
    const activeMenu = document.querySelector(`.menu-drawer__navigation_left [data-index='${firstActiveIndex}']`);
    if (!activeMenu) { return; }
    document.querySelectorAll('.menu-drawer__navigation_left [data-index]').forEach((el) => el.setAttribute('data-active', 'false'));
    activeMenu.setAttribute('data-active', 'true');
    const parentElement = activeMenu.closest('.menu-drawer__navigation_left_item');
    if (parentElement && parentElement.parentElement) {
      Array.from(parentElement.parentElement.children).forEach((el) => el.setAttribute('data-active', 'false'));
      parentElement.setAttribute('data-active', 'true');
    }
  }, 200);
}, {
  root: document.querySelector('.menu-drawer__navigation_right'),
  rootMargin: '5px 0px 0px 0px',
  threshold: 1
});
// 展开后定位到当前 menu
// const navigationDrawer = document.querySelector('navigation-drawer');
// navigationDrawer && navigationDrawer.addEventListener('dialog:after-show', () => {
//   const activeIndex = document.querySelector('.menu-drawer__navigation_new')?.getAttribute('data-default-index');
//   const activeElement = document.querySelector(`.menu-drawer__navigation_left [data-index='${activeIndex}']`);
//   if (!activeElement) { return; }
//   const parentElement = activeElement.closest('.menu-drawer__navigation_left_item');
//   Array.from(parentElement.parentElement.children).forEach((el) => el.setAttribute('data-active', 'false'));
//   parentElement.setAttribute('data-active', 'true');
//   handleMenu.call(activeElement);
// });
document.querySelectorAll('.menu-drawer__navigation_right [data-index]').forEach((el) => observer.observe(el));

let rightPanelHeight = (rightPanel ? rightPanel.clientHeight : 0);
function updatePlaceholderHeight() {
  const rightItems = document.querySelectorAll('.menu-drawer__navigation_right [data-index]');
  const lastRight = rightItems[rightItems.length - 1];
  const placeholder = document.querySelector('.menu-drawer__navigation_right-placeholder');
  if (placeholder) {
    placeholder.style.height = (rightPanelHeight - (lastRight ? lastRight.clientHeight : 0) * 1.5) + 'px';
  }
}
window.addEventListener("resize", () => {
  rightPanelHeight = (rightPanel ? rightPanel.clientHeight : 0);
  updatePlaceholderHeight();
});
const navigationDrawer = document.querySelector('navigation-drawer');
if (navigationDrawer) {
  navigationDrawer.addEventListener('dialog:after-show', () => {
    rightPanelHeight = (rightPanel ? rightPanel.clientHeight : 0);
    updatePlaceholderHeight();
  });
}
updatePlaceholderHeight();

// ================================
// custom mobile navigation script end
// ================================
